import { useState } from 'react';
import { Pressable, Text, Link } from 'components/ui';
import { Box, Flex } from '@chakra-ui/react';
import { ChevronDown } from 'lucide-react';

export const RequiredTerms = ({
  formData,
  isDisabled = false,
  onChange = () => {},
  setData,
  setShowFullRelease,
}) => {
  const [visibleSections, setVisibleSections] = useState({});

  const requiredTermsConfig = [
    {
      id: 'auth_medical_release',
      title: 'Notice of Privacy Practice',
      content: (
        <>
          I acknowledge that Ayble Health Service Corporation, providing health
          care on behalf of Ayble Health, Inc., has offered me a copy of its{' '}
          <Link
            _text={{ textTransform: 'none' }}
            isExternal
            href={'https://www.ayblehealth.com/notice-of-privacy-practices'}
          >
            Notice of Privacy Practices
          </Link>{' '}
          (“Notice”). I understand this acknowledgement (“Acknowledgment”) in no
          way affects the care I will receive from Ayble Health Service
          Corporation. I ACKNOWLEDGE I HAVE READ THIS NOTICE AND UNDERSTAND ITS
          CONTENTS AND HAVE RECEIVED A COPY HEREOF. I FURTHER ACKNOWLEDGE THAT I
          AM THE INDIVIDUAL OR PERSON DULY AUTHORIZED EITHER BY THE INDIVIDUAL
          OR OTHERWISE, TO SIGN THIS ACKNOWLEDGMENT AND TO CONSENT TO AND ACCEPT
          ITS TERMS.
        </>
      ),
    },
    {
      id: 'auth_payer_to_pay_ayble',
      title: 'Insurance Reimbursement Authorization',
      content: (
        <>
          I authorize the release of any medical or other information necessary
          to process claims to all my insurance carrier(s) and its authorized
          agents. I assign all payments, rights, and claims for reimbursement of
          claims, costs and expenses allowable under my insurance plan(s)
          directly to Ayble Health for services rendered. I understand that I am
          financially responsible for charges not covered by my insurance
          company. By checking this box I agree with these terms as well as the
          terms in the{' '}
          <Link
            _text={{ textTransform: 'none' }}
            onClick={(e) => {
              e?.stopPropagation();
              setShowFullRelease(true);
            }}
          >
            full benefits assessment.
          </Link>
        </>
      ),
    },
  ];

  return (
    <Box w="100%">
      <Text textStyle="label.section" textAlign="left" mb="10px" mt="36px">
        Please review and acknowledge the receipt of:
      </Text>

      {requiredTermsConfig.map((section) => {
        return (
          <Pressable
            disabled={isDisabled}
            key={section.id}
            w="100%"
            my="6px"
            textAlign="left"
            onClick={(e) => {
              //@ts-ignore
              if (e.target.id !== section.id) {
                setVisibleSections((prev) => ({
                  ...prev,
                  [section.id]: !prev[section.id],
                }));
              }
            }}
          >
            <Box
              bg="white"
              py="13px"
              px="16px"
              w="100%"
              borderColor="fieldBorder.200"
              borderWidth={1}
              borderRadius={visibleSections[section.id] ? '3xl' : 'full'}
            >
              <Flex direction="row" align="center" justify="space-between">
                <Flex direction="row" align="center">
                  <input
                    disabled={isDisabled}
                    type="checkbox"
                    name={section.id}
                    id={section.id}
                    style={{
                      width: '19px',
                      height: '19px',
                      flexShrink: 0,
                      accentColor: '#2D6670',
                    }}
                    checked={formData[section.id]}
                    onChange={(e) => {
                      e.stopPropagation();
                      setData({
                        ...formData,
                        [section.id]: e.target.checked,
                      });
                      onChange();
                    }}
                    data-testid={section.id}
                  />
                  <Text ml="10px" fontSize="14px" lineHeight="1.35">
                    {section.title}
                  </Text>
                </Flex>

                <Box
                  aria-hidden
                  color="secondary.200"
                  display="flex"
                  flexShrink={0}
                  style={{
                    transform: visibleSections[section.id]
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                  }}
                >
                  <ChevronDown size={14} />
                </Box>
              </Flex>
              {visibleSections[section.id] && (
                <Text mt={4} lineHeight="21px">
                  {section.content}
                </Text>
              )}
            </Box>
          </Pressable>
        );
      })}
    </Box>
  );
};

export default RequiredTerms;
